export enum BlockTextFormValues {
  DECISION_POINTS = 'decisionPoints',
  ICON_NAME = 'iconName',
  ICON_ID = 'iconId',
  MEDIA_LABELS = 'mediaLabels',
  MEDIUM_TITLE = 'mediumTitle'
}

export enum MediaTextFormValues {
  EMBED_LINK = 'embedLink'
}
